export default function (state = null, action) {
    switch (action.type) {
        case 'PROJECTS_MENU':
            return {
              projectsMenuOpen: action.payload
            };
            break;

        case 'SIDE_DRAWER':
            return {
              sideDrawerOpen: action.payload
            };
            break;

        case 'PRIORITIES_DRAWER':
            return {
              priority: action.payload,
              priorityData: action.data
            };
            break;

        case 'OMMIT_OVERLAY':
            return {
              ommitOverlayOpen: action.payload,
              ommitData: action.data
            };
            break;

        case 'ACTIONS_DRAWER':
            return {
              actions_open: action.payload,
              actions_data:action.data
            };
            break;

        case 'MORE_INFO':
            return {
              moreInfoOpen: action.payload
            };
            break;

        default:
            return {
              projectsMenuOpen: false,
              sideDrawerOpen: false,
              priority: false,
              actions_open: false,
              actions_data: [],
              priorityData:{},
              moreInfoOpen: false,
              ommitOverlayOpen: false,
            }
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/reducer.js